var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.51,30.69l4.76,-3.43l-0.22,-27.26l-4.54,3.54l0,27.15z",
    fill: "#ff8e00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.58,30.69c-17.83,-2.83 -18.33,-18.36 -0.11,-21.73l0.05,3.21c-12.92,2.16 -11.29,13.75 0,15.46l0.05,3.05z",
    fill: "#626262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m18.23,12.08c2.2,0.02 4.12,1.03 6.04,2.05l-2.82,2.1l9.03,0l0.05,-6.16l-2.82,2.1c-2.86,-1.45 -5.49,-3.18 -9.48,-3.21l0,3.1l0,0.01z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenid);
export default __webpack_public_path__ + "static/media/openid.35cc81822a01154289c6c7f49efb4419.svg";
export { ForwardRef as ReactComponent };